import React, {
  useContext,
} from 'react';
import classNames from 'classnames';

import {
  Fieldset, FieldGroup, Field,
} from '@ktag/styleguide/dist/react';

import {
  AppFormField,
  FormConfigStore,
  MunicipalityStore,
  AppSelectField,
  FormUtils,
  DeliveryInfo,
} from 'ewp-common';

interface Props {
  id?: string;
  className?: string;
  additionalClassNames?: string;
}

const ResidenceInfo = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
  } = props;

  const {
    state: formConfigState,
  } = useContext(FormConfigStore.FormConfigContext);

  const configs = formConfigState?.data?.labelsMap ?? {};

  const {
    state: municipalityState,
  } = useContext(MunicipalityStore.MunicipalityContext);

  const municipalityName = municipalityState.selectedMunicipality?.data?.gemeinde?.gemeinde_Name;

  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <div className="mt-4">
        <h2>{configs.h2Details.labelDisplayName}</h2>
        <Fieldset>
          {(() => {
            const {
              labelDisplayName,
              labelDescription,
              labelPlaceholder,
              mandatory,
            } = configs.fieldResidencesinceAndTill ?? {};
            return (
              <FieldGroup label={`${labelDisplayName.replace('{placeholder}', `in ${municipalityName}`)}${mandatory === 'true' ? '*' : ''}`} infoText={labelDescription}>
                <Field name={`${FormUtils.PERSONAL_DATA_OBJ_KEY}.fieldResidenceSince`} placeholder={labelPlaceholder} label="" additionalClassNames="field-group__without-label" />
                <Field name={`${FormUtils.PERSONAL_DATA_OBJ_KEY}.fieldResidenceTill`} placeholder={labelPlaceholder} label="" additionalClassNames="field-group__without-label" />
              </FieldGroup>
            );
          })()}
          <AppSelectField
            fieldConfig={configs.fieldLanguage}
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            options={[
              {
                value: configs.fieldLanguageOption1.labelDisplayName,
                label: configs.fieldLanguageOption1.labelDisplayName,
              },
              {
                value: configs.fieldLanguageOption2.labelDisplayName,
                label: configs.fieldLanguageOption2.labelDisplayName,
              },
            ]}
          />
          <DeliveryInfo formConfigs={configs} />
          <AppFormField
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            config={configs.fieldComments}
            multiline
          />
        </Fieldset>
      </div>

    </div>
  );
};

ResidenceInfo.defaultProps = {
  id: '',
  className: 'residenceInfo',
  additionalClassNames: '',
};

export default ResidenceInfo;
